import * as Yup from "yup"
import { VALIDATION_REGEX } from "../../config/constants"
import { removeWhiteSpaces } from "config/utils"

const branchInitialValues = {
	name: "",
	shortName: "",
	addressLine1: "",
	addressLine2: "",
	city: "",
	county: "",
	postalCode: "",
	telephone: "",
	fax: "",
	publicHolidaySchedule: "",
	lockDate: "",
	isEnabled: true,
	qualifications: [],
}

const branchValidationSchema = Yup.object().shape(
	{
		name: Yup.string()
			.required()
			.label("Name")
			.matches(VALIDATION_REGEX.nameRegex, "Special characters are not allowed in Name")
			.trim()
			.max(100),
		company: Yup.string().required().label("Organization"),
		shortName: Yup.string()
			.required()
			.matches(VALIDATION_REGEX.nameRegex, "Special characters are not allowed in Short Name")
			.label("Short Name")
			.trim()
			.max(50),
		addressLine1: Yup.string().label("Address Line1").trim().max(250),
		addressLine2: Yup.string().label("Address Line2").trim().max(250),
		city: Yup.string().label("City").trim().max(50),
		county: Yup.string()
			.transform(value => (value === "" ? null : value))
			.label("County")
			.nullable()
			.trim(),
		postalCode: Yup.string()
			.label("Postal code")
			.trim()
			.transform(value => removeWhiteSpaces(value))
			.when("postalCode", {
				is: (value: any) => value?.length,
				then: rule => rule.matches(VALIDATION_REGEX.postalCode, "Postal code must be in correct format"),
			}),
		telephone: Yup.string()
			.label("Telephone")
			.trim()
			.notRequired()
			.when("telephone", {
				is: (value: any) => value?.length,
				then: rule => rule.matches(VALIDATION_REGEX.mobile, "Telephone must be in correct format"),
			}),
		fax: Yup.string()
			.label("Fax")
			.trim()
			.when("fax", {
				is: (value: any) => value?.length,
				then: rule => rule.matches(VALIDATION_REGEX.mobile, "Fax must be in correct format"),
			}),
		publicHolidaySchedule: Yup.string().label("Public Holiday Schedule").nullable(),
		lockDate: Yup.string()
			.transform(value => (value === "" ? null : value))
			.nullable()
			.label("Branch Lock Date")
			.optional(),
		isEnabled: Yup.boolean().label("Enabled"),
		qualifications: Yup.array(Yup.string()).label("Required Qualifications"),
	},
	[
		["postalCode", "postalCode"],
		["telephone", "telephone"],
		["fax", "fax"],
	],
)

export { branchInitialValues, branchValidationSchema }
